import servise from '@/router/axios'

// 获取表格
export const getSubject = (params) => {
  return servise({
    url: '/subjectInfo/get/subject/list',
    params
  })
}
// 添加
export const addSubject = (body) => {
  return servise({
    url: '/subjectInfo/add/subject',
    method: 'post',
    data: body
  })
}
// 编辑
export const updateSubject = (body) => {
  return servise({
    url: '/subjectInfo/update/subject',
    method: 'put',
    data: body
  })
}
// 删除
export const deleteSubject = (params) => {
  return servise({
    url: '/subjectInfo/delete/subject',
    method: 'delete',
    params
  })
}
